<script setup lang="ts">
const props = defineProps<{
  type: 'text' | 'tel' | 'data' | 'number';
  using?: 'search';
  autoFocus?: boolean;
  placeholder?: string;
  maxLength?: number;
  modelValue?: string;
  disabled?: boolean;
  error?: string | boolean | undefined;
}>();

const emit = defineEmits(['update:modelValue', 'on-blur']);

const inputValue = ref(props.modelValue || '');
const inputRef = ref<HTMLInputElement | null>(null);

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  if (props.type === 'tel' || props.type === 'data') {
    value = value.replace(/\D/g, '');
  }
  if (props.maxLength && value.length > props.maxLength) {
    value = value.slice(0, props.maxLength);
  }
  inputValue.value = value;
  emit('update:modelValue', value);
};

const handleBlur = () => {
  emit('on-blur');
};
</script>

<template>
  <div :class="$style.input">
    <div :class="$style.input__wrapper">
      <input
        ref="inputRef"
        v-model="inputValue"
        :class="[
          $style.input__element,
          {
            [$style.input__element_error!]: Boolean(props.error),
          },
        ]"
        :type="props.type === 'data' ? 'text' : props.type"
        :maxlength="props.maxLength"
        :placeholder="props.placeholder"
        :aria-disabled="disabled"
        :disabled="disabled"
        @input="handleInput"
        @blur="handleBlur"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.input {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-1x);

  &__wrapper {
    height: 100%;
  }
  &__element {
    height: auto;
    width: 100%;
    height: 100%;
    border: 1px solid var(--color-gray-line);
    padding-left: var(--space-2x);
    padding-right: var(--space-2x);
    outline: none;
    @include text_body1;

    &:hover {
      outline: none;
    }

    &_error {
      border-color: var(--color-red-2);
    }
  }
}
</style>
